import type { CreateReasonParams, ReasonModel, ReasonResponse, UpdateReasonParams } from '@/domain/models/reason.js';
import { ReasonModel as ReasonModelClass } from '@/domain/models/reason.js';
import type { HttpClient } from '@/domain/protocols/http-client.js';
import type { ReasonRepository } from '@/domain/repositories/reason-repository.js';

export class ReasonRepositoryImpl implements ReasonRepository {
    constructor(private readonly httpClient: HttpClient) {}

    public async findAll(params?: { category?: string; isActive?: boolean }): Promise<ReasonModel[]> {
        const searchParams = new URLSearchParams();
        if (params?.category) {
            searchParams.set('category', params.category);
        }
        if (params?.isActive !== undefined) {
            searchParams.set('isActive', String(params.isActive));
        }
        const qs = searchParams.toString() ? `?${searchParams.toString()}` : '';
        const response = await this.httpClient.request<ReasonResponse[]>({ url: `/api/reasons${qs}`, method: 'GET' });
        return ReasonModelClass.withFromResponseList(response.body);
    }

    public async create(params: CreateReasonParams): Promise<ReasonModel> {
        const response = await this.httpClient.request<ReasonResponse>({ url: '/api/reasons', method: 'POST', body: params });
        return ReasonModelClass.withFromResponse(response.body);
    }

    public async update(id: string, params: UpdateReasonParams): Promise<ReasonModel> {
        const response = await this.httpClient.request<ReasonResponse>({ url: `/api/reasons/${encodeURIComponent(id)}`, method: 'PUT', body: params });
        return ReasonModelClass.withFromResponse(response.body);
    }

    public async toggle(id: string, active: boolean): Promise<void> {
        await this.httpClient.request({ url: `/api/reasons/${encodeURIComponent(id)}/status`, method: 'PATCH', body: { isActive: active } });
    }
}
